import store from '@/store/store';
import { MANDATAIRE_PAYEUR, REGIE } from '@/configuration/societe/societe';

export default function setAFacturerOfLigne(nouvelleLigneCommande, dcf) {
  if (!nouvelleLigneCommande.lignesCommande) return;

  const societeActive = store.getters['societe/societeActive'];

  // dcf est null si on vient du planning
  // si on passe par la ligne de commande il est !== de null
  const dcfReference = !dcf ? store.getters['commande/commande'] : dcf;

  if (!dcfReference) return;

  nouvelleLigneCommande.lignesCommande.forEach((ligneEnfant) => {
    // on recupere la valeur sur la sociéte si activerBonAFacturer est à true
    if (societeActive.activerBonAFacturer) {
      ligneEnfant.aFacturer = societeActive.bonAFacturer;
    }

    // si role du dcf est à MANDATAIRE_PAYEUR ou REGIE aFacturer est à true
    if (dcfReference && dcfReference.role
      && (dcfReference.role === MANDATAIRE_PAYEUR || dcfReference === REGIE)) {
      ligneEnfant.aFacturer = true;
    }
  });
}
